export default "<iframe [src]=\"url\"></iframe>\r\n"